import { useAuth } from './useAuth';

/**
 * Hook для условного UI: usePermissions().can('sites.create') etc.
 * Permissions подгружаются через GET /auth/me (включены в payload userPayload).
 *
 * Используется в Sidebar (видимость пунктов навигации), в /sites (CTA создания/удаления),
 * в Editor (Save/Publish кнопки) — всё что должно зависеть от роли.
 */
export function usePermissions() {
  const { user } = useAuth();
  const perms = user?.permissions ?? [];
  const setPerms = new Set(perms);
  const hidden = new Set(user?.hidden_sections ?? []);

  return {
    can: (perm: string) => setPerms.has(perm),
    /**
     * Спрятан ли раздел от этого человека (`prv3`). Отдельный вопрос от `can`:
     * право отвечает «можно ли действовать», видимость — «показывать ли раздел».
     */
    sectionHidden: (key: string) => hidden.has(key),
    hiddenSections: user?.hidden_sections ?? [],
    canAny: (...list: string[]) => list.some((p) => setPerms.has(p)),
    /**
     * Режим показа номера клиентки (`s318`) — ТРЕТИЙ вопрос, не право и не
     * видимость раздела: «как показывать данные внутри разрешённого экрана».
     * Fail-closed: сервер не сказал — считаем «наглухо».
     */
    rezhimNomera: user?.rezhim_nomera ?? 'naglukho',
    permissions: perms,
    roles: user?.roles ?? [],
    isSuperAdmin: user?.roles?.includes('super_admin') ?? false,
  };
}
